import React, { useEffect } from "react";
import Foundation from "./Foundation";
import OurTeam from "./OurTeam";
import Contributors from "./Contributors";
import AOS from "aos";
import "aos/dist/aos.css";
import "./About.css";

const About = () => {
  useEffect(() => {
    AOS.init({ 
      duration: 1200,
      once: true,
      easing: 'ease-out-cubic'
    });
  }, []);

  return (
    <div>
      <h1 className="about" data-aos="fade-down">
        <span className="about-title-text">About Us</span>
      </h1>
      <Foundation />
      <hr />
      <OurTeam />
      <hr />
      <Contributors />
    </div>
  );
};

export default About;